<!-- Landin Content -->
<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- Knowledge base Jumbotron -->
    <section class="mt-1" id="knowledge-base-search">
      <div class="row">
        <div class="col-12">
          <div style="
              background-image: url('{{court_bg_path}}');
              background-size: cover;
              background-position: 100% 100%;
            " class="card knowledge-base-bg text-center green-gradient shadow-sm">
            <div class="card-body">
              <div class="glass py-3 shadow-sm">
                <img src="{{court_logo_path}}" alt="brand-logo" width="150" class="img-fit" />
                <h1 class="mt-1 text-white">{{courtTitle}} </h1>
                <h4 class="text-primary mt-1 text-white px-3">
                  <p>Welcome to the Official Affidavit Portal of The {{courtTitle}}</p>
                  <p> Please use the links below for more information</p>
                </h4>
                <ul class="nav justify-content-center mt-1">
                  <li class="nav-item">
                    <button routerLink="/auth/login" type="button" class="btn btn-relief-primary mr-25" rippleEffect
                      [disabled]="is_portal_mode_partial === 'true'">
                      <span [data-feather]="'log-in'" [class]="'mr-25'"></span>Login
                    </button>
                  </li>
                  <li class="nav-item">
                    <button routerLink="/auth/register" type="button" class="btn btn-relief-primary" rippleEffect
                      [disabled]="is_portal_mode_partial === 'true'">
                      <span [data-feather]="'user-plus'" [class]="'mr-25'"></span>Register
                    </button>
                  </li>
                </ul>
                <!-- Maintenance Mode Message -->
                <div *ngIf="is_portal_mode_partial === 'true'" class="mt-2">
                  <div class="alert alert-warning" role="alert">
                    <i class="fas fa-tools mr-1"></i>
                    <strong>Maintenance Mode:</strong> {{ maintenanceMessage || 'Login and Registration are temporarily
                    disabled. Please try again later.' }}

                    <!-- Time-based maintenance information -->
                    <div *ngIf="timeUntilMaintenanceEnds" class="mt-2">
                      <small class="text-muted text-white">
                        <i class="fas fa-clock mr-1"></i>
                        You can return to access the portal in: <strong>{{ timeUntilMaintenanceEnds }}</strong>. You can
                        also visit any Accredited Agent for assistance.
                      </small>
                    </div>

                    <!-- Day-based maintenance information -->
                    <!-- <div *ngIf="currentMaintenanceDayStatus" class="mt-2">
                      <small class="text-muted text-white">
                        <i class="fas fa-calendar mr-1"></i>
                        {{ currentMaintenanceDayStatus }}
                      </small>
                    </div> -->
                  </div>
                </div>

                <!-- Upcoming Maintenance Warning -->
                <div *ngIf="timeUntilMaintenance && is_portal_mode_partial === 'false'" class="mt-2">
                  <div class="alert alert-info" role="alert">
                    <i class="fas fa-info-circle mr-1"></i>
                    <strong>Upcoming Maintenance:</strong> Login and Registration will be disabled in <strong>{{
                      timeUntilMaintenance }}</strong>

                    <!-- Next maintenance day information -->
                    <div *ngIf="nextMaintenanceDay" class="mt-2">
                      <small class="text-muted">
                        <i class="fas fa-calendar mr-1"></i>
                        Next maintenance day: <strong>{{ nextMaintenanceDay }}</strong>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--/ Knowledge base Jumbotron -->

    <!-- Knowledge base -->
    <section id="knowledge-base-content">
      <div class="row kb-search-content-info match-height">
        <div class="col-md-6 col-sm-6">
          <div class="card">
            <a>
              <img src="../../../../assets/img/undraw_Online_learning_re_qw08.png" class="card-img-top img-fit"
                alt="knowledge-base-image" height="350" />
              <div class="card-body text-center">
                <h4 class="text-primary">E-Affidavit</h4>
                <p class="text-body mt-1 mb-0">
                  Written Statement in which Deponent swears oath or affirms
                  his/her Statement.
                  <!--                   
                      Just like earlier people used to take oath
                      in front of God OR also we can consider the example of Courts
                      b... -->
                </p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-12 kb-search-content">
          <div class="card">
            <a>
              <img src="../../../../assets/img/undraw_Online_articles_re_yrkj.png" class="card-img-top img-fit"
                alt="knowledge-base-image" height="350" />
              <div class="card-body text-center">
                <h4 class="text-primary">E-Verification</h4>
                <p class="text-body mt-1 mb-0">
                  E-Verification allows you to verify all affidavits quickly and securely online,
                  ensuring authenticity and compliance with legal standards.
                </p>
                <p class="mb-1">Click the button below to Verify Your Affidavit</p>
                <button (click)="modalOpenVC(modalVC)" type="button" class="btn btn-primary mr-25" rippleEffect>
                  <span [data-feather]="'Verify Affidavit'" [class]="'mr-25'"></span>Verify Affidavit
                </button>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-12 kb-search-content">
          <div class="card">
            <a>
              <img src="../../../../assets/img/undraw_Meet_the_team_re_4h08.png" class="card-img-top img-fit"
                alt="knowledge-base-image" height="350" />
              <div class="card-body text-center">
                <h4 class="text-primary">Accredited Agents</h4>
                <p class="text-body mt-1 mb-0">
                  Accredited agents are individuals or organizations authorized to assist with submitting requests to
                  the court on behalf of a party.
                </p>
                <a [href]="agent_portal_url" target="_blank" class="btn btn-primary mr-25 mt-3" rippleEffect>
                  <span [data-feather]="'Accredited Agents'" [class]="'mr-25'"></span>Register as Agent
                </a>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 col-12 kb-search-content">
          <div class="card">
            <a>
              <img src="../../../../assets/img/undraw_document-ready_o5d5.png" class="card-img-top img-fit"
                alt="knowledge-base-image" height="350" />
              <div class="card-body text-center">
                <h4 class="text-primary">Police Extract</h4>
                <p class="text-body mt-1 mb-0">
                  An official document issued by the police to report lost items (documents, phones), register changes
                  in vehicle
                  engine/chassis, or report incidents like robbery.
                </p>
                <a [href]="possap_url" target="_blank" class="btn btn-primary mr-25 mt-3" rippleEffect>
                  <span [data-feather]="'Request Police Extract'" [class]="'mr-25'"></span>Request Police Extract
                </a>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Landin Content -->

<!-- Modal -->
<ng-template #modalVC let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalCenterTitle">
      Verify Affidavit
    </h5>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="border rounded shadow-sm pt-3 px-3 bg-white">
      <ul class="timeline">
        <li class="timeline-item">
          <span class="timeline-point timeline-point-indicator"></span>
          <div class="timeline-event">
            <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
              <h4 class="card-title text-primary">Verify Your Affidavit</h4>
            </div>
            <form class="form" role="form">
              <div class="form-body">
                <div class="row">
                  <div class="col-md-12">
                    <label>Ref No:</label><i class="text-danger">*</i>
                    <div class="form-group">
                      <input #refNo type="text" id="refNo" class="form-control" placeholder="Enter Ref No:"
                        [formControl]="refNoControl" />
                      <div *ngIf="refNoControl.invalid && refNoControl.touched">
                        <small *ngIf="refNoControl.errors?.required" class="text-danger">
                          Affidavit Ref No is Required</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-actions right">
                <button type="button" class="btn btn-primary btn-sm " rippleEffect [disabled]="refNoControl.invalid"
                  (click)="navigateToVerification(refNo.value); modal.close()">
                  <span class="align-middle d-sm-inline-block d-none">Verify</span>
                  <i [data-feather]="'loader'" class="align-middle ml-sm-25 ml-0"></i>
                </button>
              </div>
            </form>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modal.close('Accept click')" rippleEffect>
      Close
    </button>
  </div>
</ng-template>
<!-- / Modal -->

<!-- Welcome Modal -->
<ng-template #welcomeModal let-modal>
  <div class="modal-header bg-primary text-white welcome-modal">
    <!-- <div class="d-flex align-items-center">
      <div class="welcome-icon-wrapper me-3">
        <span [data-feather]="'shield'" class="welcome-header-icon"></span>
      </div>
      <div>
        <h4 class="mb-0 text-white fw-bold">Welcome to the Portal</h4>
        <p class="mb-0 text-white-50 small">Official Probate and Process Portal</p>
      </div>
    </div> -->
    <button type="button" class="close" (click)="modal.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body welcome-modal-body" tabindex="0" ngbAutofocus>
    <!-- Hero Section -->
    <!-- <div class="text-center mb-4">
      <div class="welcome-logo-wrapper mb-3">
        <img src="{{court_logo_path}}" alt="Court Logo" class="welcome-logo" />
      </div>
      <h3 class="text-primary fw-bold mb-2">Your Gateway to Efficient Legal Services</h3>
      <p class="text-muted mb-0">Streamlined document management and legal process handling</p>
    </div> -->

    <!-- Quick Info Cards -->
    <!-- <div class="row g-3 mb-4">
      <div class="col-md-4">
        <div class="welcome-info-card">
          <div class="info-card-icon bg-primary-light">
            <span [data-feather]="'clock'" class="text-primary"></span>
          </div>
          <h6 class="mb-1">72-Hour Rule</h6>
          <p class="small text-muted mb-0">Drafts expire if no payment</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="welcome-info-card">
          <div class="info-card-icon bg-warning-light">
            <span [data-feather]="'alert-circle'" class="text-warning"></span>
          </div>
          <h6 class="mb-1">Quick Response</h6>
          <p class="small text-muted mb-0">Respond to queries promptly</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="welcome-info-card">
          <div class="info-card-icon bg-info-light">
            <span [data-feather]="'lock'" class="text-info"></span>
          </div>
          <h6 class="mb-1">Secure Process</h6>
          <p class="small text-muted mb-0">Protected with security features</p>
        </div>
      </div>
    </div> -->

    <!-- Terms & Conditions -->
    <div class="welcome-terms-section">
      <div class="terms-header mb-4 text-center">
        <h4 class="text-danger fw-bold mb-2">
          <!-- <span [data-feather]="'alert-triangle'" class="me-2"></span> -->
          ⚠️ Important Notice – Please Read
        </h4>
        <p class="mb-0">Welcome to the {{currentState}} e-Affidavit Portal</p>
      </div>

      <div class="terms-content">
        <!-- Welcome Message -->
        <div class="welcome-message mb-4">
          <p class="text-dark mb-2">
            This platform has been established to provide a secure and efficient process for affidavit applications and
            any related court services.
          </p>
          <p class="text-dark mb-0">
            By continuing, you confirm that you have read, understood, and agree to be bound by our
            <strong>
              <a href="assets/docs/terms.pdf" class="text-decoration-none fw-bold" target="_blank"
                rel="noopener noreferrer">
                <span [data-feather]="'external-link'" class="me-1"></span>Terms and Conditions
              </a>
            </strong> and <strong><a href="assets/docs/policy.pdf" class="text-decoration-none fw-bold" target="_blank"
                rel="noopener noreferrer">
                <span [data-feather]="'external-link'" class="me-1"></span>Privacy Policy
              </a></strong>, issued in compliance with the <strong>Nigeria Data Protection Act (NDPA) 2023</strong>.
          </p>
        </div>

        <!-- Key Information Section -->
        <div class="key-info-section mb-4">
          <h5 class="text-primary fw-bold mb-3">
            <span [data-feather]="'key'" class="me-2 mr-1"></span>
            Key Information for Applicants
          </h5>

          <!-- Data Collection -->
          <div class="info-section mb-3">
            <h6 class="fw-bold text-dark mb-2">1. Data Collection & Use</h6>
            <ul class="list-unstyled mb-0">
              <li class="mb-1">We collect personal data (including NIN, passport photograph, signature, and contact
                details) solely for affidavit applications, verification, and lawful purposes.</li>
              <li class="mb-0">Your information is protected under strict security measures and will only be shared with
                authorized entities in compliance with applicable laws.</li>
            </ul>
          </div>

          <!-- Document Requirements -->
          <div class="info-section mb-3">
            <h6 class="fw-bold text-dark mb-2">2. Document Requirements</h6>
            <p class="text-dark mb-2">To ensure smooth and timely approval of your application, you must provide:</p>
            <ul class="list-unstyled mb-0">
              <li class="mb-1">A corporate-standard passport photograph (clear, recent, and compliant with court
                specifications).</li>
              <li class="mb-1">A clear and legible signature on a plain white background.</li>
              <li class="mb-0">A valid government-issued means of identification (e.g., NIN, International Passport,
                Driver's License, or Voter's Card).</li>
            </ul>
          </div>

          <!-- Applicant Obligations -->
          <div class="info-section mb-3">
            <h6 class="fw-bold text-dark mb-2">3. Applicant Obligations</h6>
            <ul class="list-unstyled mb-0">
              <li class="mb-1">You must validate your application by making the required payment.</li>
              <li class="mb-0">If queried for additional details or documents, you must respond within <span
                  class="text-dark fw-bold"><strong>seventy-two (72) hours</strong></span>.</li>
            </ul>
          </div>

          <!-- Warning Notice -->
          <div class="warning-notice mb-3">
            <div class="text-danger" role="alert">
              <div class="d-flex">
                <!-- <span [data-feather]="'alert-triangle'" class="me-2 text-warning"></span> -->
                <div>
                  ⚠️ Failure to make payment or respond to queries within the stipulated time will result in automatic
                  deletion of your application, without refund and without notice. In such cases, a new application and
                  fresh payment will be required.
                </div>
              </div>
            </div>
          </div>

          <!-- Payments -->
          <div class="info-section mb-3">
            <h6 class="fw-bold text-dark mb-2">4. Payments</h6>
            <ul class="list-unstyled mb-0">
              <li class="mb-1">All payments are <strong><span class="text-danger">final, non-refundable, and
                    non-transferable</span></strong>.</li>
              <li class="mb-0">Applicants are strongly advised to carefully review their information before completing
                payment.</li>
            </ul>
          </div>

          <!-- Affidavit Authenticity -->
          <div class="info-section mb-3">
            <h6 class="fw-bold text-dark mb-2">5. Affidavit Authenticity</h6>
            <ul class="list-unstyled mb-0">
              <li class="mb-1">All affidavits issued through this portal are protected with unique barcodes and
                reference numbers for verification.</li>
              <li class="mb-0">Any attempt to falsify, alter, or misuse affidavits constitutes a criminal offence and
                will attract legal consequences.</li>
            </ul>
          </div>

          <!-- NDPA Rights -->
          <div class="info-section mb-3">
            <h6 class="fw-bold text-dark mb-2">6. Your Rights under the NDPA</h6>
            <p class="text-dark mb-2">As a data subject, you have the right to:</p>
            <ul class="list-unstyled mb-0">
              <li class="mb-1">Access, update, or correct your personal data.</li>
              <li class="mb-1">Request deletion or restrict processing where applicable.</li>
              <li class="mb-1">Withdraw consent for optional services.</li>
              <li class="mb-0">Lodge complaints with the Nigeria Data Protection Commission (NDPC) if you believe your
                rights have been violated.</li>
            </ul>
          </div>

          <!-- Contact Information -->
          <div class="info-section mb-3">
            <h6 class="fw-bold text-dark mb-2">7. Contact Information</h6>
            <ul class="list-unstyled mb-0">
              <li class="mb-1">
                <strong>Privacy & Data Protection Enquiries:</strong>
                <a href="mailto:privacy_ecms@fhc.gov.ng" class="text-decoration-none text-primary" target="_blank"
                  rel="noopener noreferrer">
                  <span [data-feather]="'mail'" class="me-1"></span>privacy_ecms@fhc.gov.ng
                </a>
              </li>
              <li class="mb-0">
                <strong>General Support:</strong>
                <a href="mailto:info@fhc.gov.ng" class="text-decoration-none text-primary" target="_blank"
                  rel="noopener noreferrer">
                  <span [data-feather]="'mail'" class="me-1"></span>info@fhc.gov.ng
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Final Consent -->
        <!-- <div class="final-consent mb-3">
           <div class="alert alert-info border-0" role="alert">
             <div class="d-flex">
               <span [data-feather]="'check-circle'" class="me-2 text-info"></span>
               <div>
                 <strong>Final Notice:</strong> By clicking "I Agree & Continue", you expressly consent to these terms and acknowledge your obligations as an applicant.
               </div>
             </div>
           </div>
         </div> -->
      </div>
    </div>
  </div>

  <div class="modal-footer welcome-modal-footer">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="modal.dismiss()">
      <span [data-feather]="'x'" class="me-2"></span>Cancel
    </button>
    <button type="button" class="btn btn-success" (click)="modal.close()">
      <!-- <span [data-feather]="'check-circle'" class="me-2"></span>-->I Agree & Continue
    </button>
  </div>
</ng-template>
<!-- / Welcome Modal -->